import { render, staticRenderFns } from "./AddAffiliation.vue?vue&type=template&id=3c832dd9&scoped=true"
import script from "./AddAffiliation.vue?vue&type=script&lang=js"
export * from "./AddAffiliation.vue?vue&type=script&lang=js"
import style0 from "./AddAffiliation.vue?vue&type=style&index=0&id=3c832dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c832dd9",
  null
  
)

export default component.exports